import { t } from "../i18n";
import { useEffect, useState } from "react";
import { Laptop, Moon, Sun } from "lucide-react";
import type { ThemePreference } from "@lumen/shared";

const options = [
  { value: "light" as const, icon: Sun, label: t("Light") },
  { value: "dark" as const, icon: Moon, label: t("Dark") },
  { value: "system" as const, icon: Laptop, label: t("System") },
];
function apply(theme: ThemePreference) {
  const dark =
    theme === "dark" ||
    (theme === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
}

export function ThemeSwitch() {
  const [theme, setTheme] = useState<ThemePreference>(
    () => (localStorage.getItem("lumen-theme") as ThemePreference) || "system",
  );
  useEffect(() => {
    apply(theme);
    localStorage.setItem("lumen-theme", theme);
    const media = matchMedia("(prefers-color-scheme: dark)");
    const listener = () => apply(theme);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [theme]);
  return (
    <div
      className="flex rounded-xl bg-stone-100 p-1 dark:bg-white/5"
      aria-label={t("Color theme")}
    >
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          title={label}
          aria-label={label}
          aria-pressed={theme === value}
          className={`rounded-lg p-1.5 transition ${theme === value ? "bg-white text-lumen-700 shadow-sm dark:bg-white/10 dark:text-lumen-300" : "text-stone-400 hover:text-stone-700 dark:hover:text-stone-200"}`}
        >
          <Icon size={15} />
        </button>
      ))}
    </div>
  );
}
